import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules/index.js';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true, // This makes the Vuex store strict
  state: {
    snackbarHandler: null,
  },
  mutations: {
    setSnackbarHandler(state, handler) {
      state.snackbarHandler = handler;
    },
  },
  actions: {
    showSnack({ state }, snack) {
      if (state.snackbarHandler) {
        state.snackbarHandler(snack);
      }
    },
  },
  modules,
});

// Automatically run the `init` action for every module,
// if one exists.
Object.keys(modules).reduce(async (p, moduleName) => {
  await p;
  if (modules[moduleName].actions.init) {
    p = store.dispatch(`${moduleName}/init`);
  }

  return p;
}, Promise.resolve());
export default store;
